import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const activityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);

    return {
      getActivities: query({
        query: () => "/activity",
        transformResponse: (responseData) => {
          const loadedActivity = responseData.map((activity) => {
            activity.id = activity._id;
            return activity;
          });
          return loadedActivity;
        },
        providesTags: ["Activities"],
      }),
    };
  },
});

// Destructure and export hooks
export const { useGetActivitiesQuery } = activityApiSlice;
